import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setPreguntaActiva,
  setAnswer,
  getUsuario,
  setRespuesta,
} from "../actions";

// 1. Importamos Spinner y Alert
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";

import { Instrumento } from "./Instrumento";

// 2. Función para obtener siguiente pregunta Random
const obtenerSiguientePregunta = (todasLasPreguntas, respuestasActuales) => {
  const preguntasPendientes = todasLasPreguntas.filter(
    (pregunta) =>
      !respuestasActuales.some((r) => r.id_pregunta === pregunta.id_pregunta)
  );
  if (preguntasPendientes.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * preguntasPendientes.length);
  return preguntasPendientes[randomIndex].id_pregunta;
};

const Pregunta202 = (props) => {
  // Corregido: useDispatch no recibe parámetros
  const dispatch = useDispatch();

  // 3. Estados de carga y error
  const [isSaving, setIsSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [values, setValues] = useState({
    seleccionada: 0,
    instrucciones_visible: true,
    evaluar: 0,
  });

  const [submitted, setSubmitted] = useState(false);

  const preguntaActiva = useSelector((state) => state.preguntaActiva);
  const ticket = useSelector((state) => state.ticket);

  const HandleClickVolver = () => {
    dispatch(
      setPreguntaActiva({
        id_instrumento: 0,
        id_pregunta: 0,
        contador: 0,
        //respuestas202: [], // Limpiamos historial al salir
      })
    );
  };

  if (values.evaluar === 1) return <Navigate to="/eval2" replace={true} />;

  if (preguntaActiva.id_instrumento === 0)
    return <Navigate to="/inicio" replace={true} />;

  const HandleClick1 = (val) => {
    setValues((values) => ({
      ...values,
      seleccionada: val,
    }));
    if (errorMsg) setErrorMsg(""); // Limpiar error al seleccionar
  };

  const HandleClickInstrucciones = () => {
    setValues((values) => ({
      ...values,
      instrucciones_visible: !values.instrucciones_visible,
    }));
  };

  // LOGICA SIGUIENTE (ASYNC + RANDOM)
  const HandleClickSiguiente = async () => {
    setIsSaving(true);
    setErrorMsg("");

    try {
      // 1. Guardar en API (Await)
      const _props = {
        token: "c3649ba4e3a81815",
        function: "SetRespuesta",
        params: {
          ticket: ticket.Ticket,
          id_proceso: 1,
          id_usuario: ticket.id_usuario,
          id_pregunta: preguntaActiva.id_pregunta,
          respuesta: values.seleccionada,
          respuesta_texto: "",
          respuesta_2: 0,
          respuesta_texto_2: "",
          respuesta_3: 0,
          respuesta_texto_3: "",
        },
      };

      await dispatch(setRespuesta(_props));

      // 2. Actualizar array local (Upsert) para el Random
      const _respuesta = {
        id_pregunta: preguntaActiva.id_pregunta,
        respuesta: values.seleccionada,
      };

      const currentRespuestas = preguntaActiva.respuestas202 || [];
      const existingIndex = currentRespuestas.findIndex(
        (item) => item.id_pregunta === _respuesta.id_pregunta
      );

      let updatedRespuestas;
      if (existingIndex >= 0) {
        updatedRespuestas = currentRespuestas.map((item, index) =>
          item.id_pregunta === _respuesta.id_pregunta
            ? { ...item, ..._respuesta }
            : item
        );
      } else {
        updatedRespuestas = [...currentRespuestas, _respuesta];
      }

      // 3. Obtener Instrumento y Randomizar
      const _instrumento = Instrumento.find(
        (el) => el.id_instrumento === preguntaActiva.id_instrumento
      );

      const idSiguiente = obtenerSiguientePregunta(
        _instrumento.preguntas,
        updatedRespuestas
      );

      const nextId =
        idSiguiente !== null ? idSiguiente : preguntaActiva.id_pregunta;

      // 4. Actualizar Redux
      dispatch(
        setPreguntaActiva({
          id_instrumento: preguntaActiva.id_instrumento,
          id_pregunta: nextId,
          contador: preguntaActiva.contador + 1,
          respuestas202: updatedRespuestas,
        })
      );

      // 5. Reset local (Manteniendo visibilidad de instrucciones según estado anterior)
      setValues((prev) => ({
        ...prev,
        seleccionada: 0,
        instrucciones_visible: false,
        // No forzamos instrucciones_visible a false aquí para no colapsar el menú bruscamente,
        // o puedes ponerlo en false si prefieres que se cierren al avanzar.
      }));
    } catch (error) {
      console.error(error);
      setErrorMsg("Error al guardar respuesta. Intente nuevamente.");
    } finally {
      setIsSaving(false);
    }
  };

  const _instrumento = Instrumento.find((element) => {
    return element.id_instrumento === preguntaActiva.id_instrumento;
  });

  const _preg = _instrumento?.preguntas.find((element) => {
    return element.id_pregunta === preguntaActiva.id_pregunta;
  });

  // FIN DEL TEST
  if (_instrumento.total_preguntas < preguntaActiva.contador || !_preg)
    return (
      <Container>
        <h1 className="mt-4">Fin de Test</h1>
        <hr />
        <Row>
          <Col>
            <p className="xz-texto-v ">Has finalizado este test.</p>
            <p className="xz-texto-v ">Sigue adelante !</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button className="xz-btn-pregunta" onClick={HandleClickVolver}>
              Volver al Inicio
            </Button>
          </Col>
        </Row>
      </Container>
    );

  // BOTÓN CON SPINNER
  const avanzar_siguiente = () => {
    if (values.seleccionada > 0)
      return (
        <Col className="text-end">
          <Button onClick={HandleClickSiguiente} disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Guardando...
              </>
            ) : (
              "Avanzar a Siguiente Pregunta"
            )}
          </Button>
        </Col>
      );
  };

  const Instrucciones = () => {
    if (values.instrucciones_visible)
      return (
        <Row className="mt-4">
          <Col className="col-12 col-md-12">
            <h4>Instrucciones</h4>
            <p>
              A continuación, encontrará un conjunto de afirmaciones frente a
              las cuales usted debe señalar el nivel de acuerdo con lo que usted
              piensa, siente o cree. No hay respuestas correctas o incorrectas,
              simplemente señalan lo que usted considera respecto de sí mismo/a.
              Responda todas las afirmaciones para que se pueda corregir el
              cuestionario. El tiempo estimado de respuesta es de 10 minutos.
            </p>
            <p>
              Frente a cada afirmación usted deberá marcar en una escala de 6
              posiciones su nivel de desacuerdo o acuerdo, siendo 1
              completamente en desacuerdo y 6 completamente de acuerdo.
            </p>
            <p></p>
          </Col>
        </Row>
      );
    else
      return (
        <Row>
          <Col>
            <p>
              Frente a cada afirmación usted deberá marcar en una escala de 6
              posiciones su nivel de desacuerdo o acuerdo.
            </p>
          </Col>
        </Row>
      );
  };

  const _opcion1_class =
    values.seleccionada === 1 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion2_class =
    values.seleccionada === 2 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion3_class =
    values.seleccionada === 3 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion4_class =
    values.seleccionada === 4 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion5_class =
    values.seleccionada === 5 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";
  const _opcion6_class =
    values.seleccionada === 6 ? "xz-btn-pregunta-4" : "xz-btn-pregunta";

  return (
    <Container>
      <Row>
        <Col>
          <h3 className="mt-4 xz-titulo1">
            Pregunta {preguntaActiva.contador} de {_instrumento.total_preguntas}
          </h3>
          <Col className="col-12 col-md-4">
            <span
              className="xz-texto-instrucciones"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={HandleClickInstrucciones}
            >
              {values.instrucciones_visible
                ? "Cerrar Instrucciones"
                : "Ver Instrucciones"}
            </span>
          </Col>
        </Col>
        <Col>
          <h3 className="mt-4 xz-titulo2 text-end">
            {_instrumento.nombre_instrumento}
          </h3>
        </Col>
      </Row>{" "}
      <hr />
      {/* SECCION INSTRUCCIONES */}
      <Row>
        <Col className="col-12 xz-texto-instrucciones">{Instrucciones()}</Col>
      </Row>
      <hr />
      {/* ESTRUCTURA VISUAL ORIGINAL MANTENIDA */}
      <Row>
        {/* Columna Izquierda: Texto */}
        <Col className="col-12 col-sm-6 xz-pregunta1">
          <p className="">{_preg.texto}</p>
        </Col>

        {/* Columna Derecha: Botones (6 Opciones) */}
        <Col>
          <Row>
            <Col>
              <Button
                className={_opcion1_class}
                onClick={() => HandleClick1(1)}
              >
                {_preg.alt1}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion2_class}
                onClick={() => HandleClick1(2)}
              >
                {_preg.alt2}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion3_class}
                onClick={() => HandleClick1(3)}
              >
                {_preg.alt3}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion4_class}
                onClick={() => HandleClick1(4)}
              >
                {_preg.alt4}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion5_class}
                onClick={() => HandleClick1(5)}
              >
                {_preg.alt5}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion6_class}
                onClick={() => HandleClick1(6)}
              >
                {_preg.alt6}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <hr className="mt-5" />
      {/* MENSAJE DE ERROR (Insertado antes del footer) */}
      {errorMsg && (
        <Row className="mb-3">
          <Col>
            <Alert variant="danger">{errorMsg}</Alert>
          </Col>
        </Row>
      )}
      {/* FOOTER */}
      <Row>
        <Col className="col-3 text-start">
          <span
            className="xz-texto-nota"
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={HandleClickVolver}
          >
            Volver al Inicio
          </span>
        </Col>
        <Col>
          <p className="xz-texto-nota ">{avanzar_siguiente()}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Pregunta202;
